import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { computed as _computed } from 'vue';

import { IonCol, IonRow } from "@ionic/vue";
import { useForm } from "vee-validate";

import TextareaSimple from "@/components/input/TextareaSimple.vue";

import { ISSUE_TYPE } from "@/types/enum/general";
import { FeedbackFeatureProps } from "@/types/props";
import { FeedbackFeatureEmits } from "@/types/emits";


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackFeature',
  props: {
    modelValue: {},
    show: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
const props = __props
const emit = __emit

const descriptionTemplate = _computed({
    get: () => {
        return props.modelValue
    },
    set: (value) => {
        emit('update:modelValue', value)
    }
})

const { meta, resetForm, validate } = useForm({
    validationSchema: {
        expectation: 'required',
        place: 'required'
    }
})

__expose({
    meta,
    resetForm,
    validate
})

return (_ctx: any,_cache: any) => {
  return (__props.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).FEATURE}.expectation`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(TextareaSimple, {
                  modelValue: descriptionTemplate.value.expectation,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((descriptionTemplate.value.expectation) = $event)),
                  "validate-option": { name: 'expectation', label: _ctx.$t('label.expectation') }
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), { class: "fs-smaller grey1-grey1-color" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t(`placeholder.${_unref(ISSUE_TYPE).FEATURE}.place`)) + "* ", 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_unref(IonRow), null, {
          default: _withCtx(() => [
            _createVNode(_unref(IonCol), null, {
              default: _withCtx(() => [
                _createVNode(TextareaSimple, {
                  modelValue: descriptionTemplate.value.place,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((descriptionTemplate.value.place) = $event)),
                  "validate-option": { name: 'place', label: _ctx.$t('label.place') }
                }, null, 8, ["modelValue", "validate-option"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}
}

})